export class Share {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.widthType = "自动"
    this.heightType = "自动"
    this.width = 312
    this.height = 32
    this.top = 0
    this.left = 0
    this.innerElement = "cxShare"
    this.content = "分享"
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.mainConfig = {}
    this.shareBtnConfig = {}
    this.itemList = [
      {
        id: 0, // 微信分享
        iconSrc: "https://p.cldisk.com/star3/origin/29fadbec1de7c54f5f256dece14e20a3.png?rw=64&rh=64&_fileSize=1066&_orientation=1",
        iconType: "img",
        isShow: true,
        name: ""
      },{
        id: 1,// 微博分享
        iconSrc: "https://p.cldisk.com/star3/origin/a0bc6fd754f0bb4b7567bb25ee017393.png?rw=64&rh=64&_fileSize=1898&_orientation=1",
        iconType: "img",
        isShow: true,
        name: ""
      },{
        id: 2,// qq分享
        iconSrc: "https://p.cldisk.com/star3/origin/deb419f5300bcdc76ca516534961febe.png?rw=64&rh=64&_fileSize=1467&_orientation=1",
        iconType: "img",
        isShow: true,
        name: ""
      },{
        id: 3,// qq空间
        iconSrc: "https://p.cldisk.com/star3/origin/7d8dc2edfbb0d9ae1146cac530f4c33b.png?rw=64&rh=64&_fileSize=1198&_orientation=1",
        iconType: "img",
        isShow: true,
        name: ""
      },{
        id: 4,// 复制链接
        iconSrc: "https://p.cldisk.com/star3/origin/71247c55ab39300f4719100435731e2e.png?rw=64&rh=64&_fileSize=1275&_orientation=1",
        iconType: "img",
        isShow: true,
        name: ""
      }
    ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
